/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { createContext, useContext } from 'react';
import type { AgentLauncherStatus } from './launcherStatus';

export type AgentLauncherValue = {
  status: AgentLauncherStatus;
  /** The Agent is open, so there is nothing to launch. */
  hidden: boolean;
  onOpen: () => void;
};

/**
 * Kept apart from the Agent panel context so the chip, which the top bar renders, re-renders on
 * status changes without the whole Agent subtree doing so.
 */
export const AgentLauncherContext = createContext<AgentLauncherValue | null>(null);

export const useAgentLauncher = () => useContext(AgentLauncherContext);
